module.exports = __webpack_public_path__ + "img/globe.181ebb60.svg";